import { generateDefaultSelectors } from "@/redux/selectors.utils";

import { $PaymentModuleName } from "./payment.types";

const { isLoading, isSuccessfullyLoaded } =
    generateDefaultSelectors($PaymentModuleName);

export { isLoading, isSuccessfullyLoaded };
